import { AServicePropertyFilterAndOrder } from '../types';

/**
 * Дефолтный стейт кеша доп. услуг.
 */
export class DefaultServiceFilterAndOrderState implements AServicePropertyFilterAndOrder {
  Variants = {};
}
